import * as CANNON from 'cannon-es';

type PadSpec = { x: number; z: number; radius: number; boostY: number };

const DEFAULT_RADIUS = 1.4;
const DEFAULT_BOOST_Y = 11;
const GROUND_Y_MAX = 2.5;
const BOOST_COOLDOWN_S = 0.35;

export class FpsJumpPadField {
  private readonly pads: PadSpec[] = [];
  private readonly lastBoostAt: number[] = [];

  constructor(positions: { x: number; z: number; radius?: number; boostY?: number }[]) {
    for (const p of positions) {
      this.pads.push({
        x: p.x,
        z: p.z,
        radius: p.radius ?? DEFAULT_RADIUS,
        boostY: p.boostY ?? DEFAULT_BOOST_Y,
      });
      this.lastBoostAt.push(0);
    }
  }

  /**
   * Applies a one-shot upward boost when the body is over a pad, grounded, and off cooldown.
   */
  tryBoost(bodyPos: CANNON.Vec3, bodyVelocity: CANNON.Vec3, _dt: number): boolean {
    if (bodyPos.y >= GROUND_Y_MAX) return false;
    const now = performance.now() * 0.001;
    for (let i = 0; i < this.pads.length; i++) {
      const pad = this.pads[i];
      const dx = bodyPos.x - pad.x;
      const dz = bodyPos.z - pad.z;
      if (dx * dx + dz * dz >= pad.radius * pad.radius) continue;
      if (now - (this.lastBoostAt[i] ?? 0) < BOOST_COOLDOWN_S) continue;
      bodyVelocity.y += pad.boostY;
      this.lastBoostAt[i] = now;
      return true;
    }
    return false;
  }
}
